import Skeleton from "@mui/material/Skeleton";

export const WidgetSkeleton = () => {


  return (
    <div style={ {
      padding: "1rem", display: "flex", flexDirection: "column", gap: "1rem"
    } }>
      <Skeleton variant="text" animation="wave" width={ "12rem" } height={ "1.5rem" } />
      <Skeleton variant="text" animation="wave" width={ "12rem" } height={ "1.5rem" } />
      <Skeleton variant="text" animation="wave" width={ "14rem" } height={ "1.5rem" } />
      <Skeleton variant="text" animation="wave" width={ "14rem" } height={ "1.5rem" } />
    </div>
  );
};
